module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/17_c696e01487ef16dca84626fe32310c29.jpg";